import React, { useState } from 'react';

import { UseMutateFunction, useMutation, useQuery } from '@tanstack/react-query';
import axios, { AxiosResponse } from 'axios';

const errorMessage: string = 'Something went wrong!';

interface Props {
    url: string;
    method: 'post' | 'put' | 'delete' | 'get';
    onSuccess?: (data: AxiosResponse<any, any>) => void;
}

interface outputType {
    loading: boolean;
    mutate: UseMutateFunction<AxiosResponse<any, any> | undefined, Error, any, unknown>;
}

function useCommonMutationHandler({ url, method, onSuccess }: Props): outputType {
    // Queries
    const { isPending, isPaused, mutate } = useMutation({
        mutationFn: async (inputData: any) => {
            //write onsuccess and onerror where mutate function is called
            try {
                const data = await axios({
                    method,
                    url,
                    data: { ...inputData },
                });
                return data;
            } catch (error) {
                throw error;
            }
        },
        onSuccess: (data) => {
            if (onSuccess) {
                onSuccess(data);
            }
        },
    });
    const apiLoading = isPaused || isPending;

    const outputData: outputType = {
        loading: apiLoading,
        mutate,
    };
    return outputData;
}

export { useCommonMutationHandler };
